export default __webpack_public_path__ + "static/media/face_with_steam_from_nose.26daeb0e.png";